import React from 'react'
import {BeWizrLibraryItem, BeWizrLibraryItemType} from '~/models'

const registry: Map<BeWizrLibraryItemType, React.ComponentType<BeWizrLibraryItemProps<any>>> = new Map()

export function getLibraryItemComponent(item: BeWizrLibraryItem) {
  return registry.get(item.type)
}

export function register<M extends BeWizrLibraryItem['item']>(type: BeWizrLibraryItemType, component: React.ComponentType<BeWizrLibraryItemProps<M>>) {
  registry.set(type, component)
}

export interface BeWizrLibraryItemProps<M> {
  item: M
}